import { useContext, useEffect, useState } from 'react';
import { Module, UserContext } from '../../../../../../Context/UserContext/UserContext';
// import { useComplianceSession } from '../../../../../../Context/ComplianceSessionContext';
import { ModuleContext } from '../../../../../../Context/ModuleContext/ModuleContext';
import { useIntl } from 'react-intl';

interface ILawData {
  id: number;
  name: string;
}

export const useComplianceState = () => {
  // const { createComplianceSession } = useComplianceSession();
  const { complianceUserFor,hasAccessToModule,customerFeatures } = useContext(UserContext);
  const { setHeader } = useContext(ModuleContext);
  const { formatMessage } = useIntl();
  const [lawsSelectedForCompliance, setLawsSelectedForCompliance] = useState<ILawData[]>([]);
  const [enabled, setEnabled] = useState<boolean>(false);
  const hasCompliance = (predicate: (law: ILawData) => boolean) => lawsSelectedForCompliance.some(predicate);

  const toggleCompliance = (row: ILawData) => {
    if (hasCompliance((x) => x.id === row.id)) {
      setLawsSelectedForCompliance(lawsSelectedForCompliance.filter((x) => x.id !== row.id));
    } else {
      setLawsSelectedForCompliance([...lawsSelectedForCompliance, row]);
    }
  };

  const startComplianceSession = () => {
    if (lawsSelectedForCompliance.length > 0) {
      // const session = createComplianceSession(lawsSelectedForCompliance);
      // setEnabled(false);
      // setLawsSelectedForCompliance([]);
      // history.push(session.todo[0].complianceUrl);
    }
  };
  useEffect(() => {
     const hasAvvikelserLight = customerFeatures?.some((feature: any) => feature.value === 13);
        let menu: any = [];
        if (hasAccessToModule(Module.Administration) || hasAccessToModule(Module.Organization)) {
          menu = [
            {
              title: formatMessage({ id: 'law-portal.legal.compliance.sub-menu.planning.lek' }),
              to: `/law-portal/legal-compliance-control/planning`,
            },
            {
              title: formatMessage({ id: 'law-portal.legal.compliance.sub-menu.carry.lek' }),
              to: `/law-portal/legal-compliance-control/carry`,
            },
            {
              title: formatMessage({ id: 'law-portal.legal.compliance.sub-menu.reports.lek' }),
              to: `/law-portal/legal-compliance-control/reports`,
            }
          ];
        } else {
          menu = [
            {
              title: formatMessage({ id: 'law-portal.legal.compliance.sub-menu.carry.lek' }),
              to: `/law-portal/legal-compliance-control/carry`,
            },
            {
              title: formatMessage({ id: 'law-portal.legal.compliance.sub-menu.reports.lek' }),
              to: `/law-portal/legal-compliance-control/reports`,
            }
          ];
        }
        if (hasAvvikelserLight) {
          menu.push({
            title: formatMessage({ id: 'law-portal.legal.compliance.sub-menu.reports.observations' }),
            to: `/law-portal/legal-compliance-control/observations`,
          })
        }
    setHeader(formatMessage({ id: 'law-portal.legal.compliance.header', defaultMessage: 'Evaluation control' }), menu);
  }, [setHeader, formatMessage]);
  return {
    enableCompliance: complianceUserFor.laws.length > 0 ? () => setEnabled(true) : undefined,
    disableCompliance: () => setEnabled(false),
    complianceEnabled: enabled,
    toggleCompliance,
    startComplianceSession,
    hasCompliance,
    isComplianceUserFor: (lawId: number) => complianceUserFor.laws.some((x) => x.id === lawId),
    isComplianceUserForreq: (reqId: number) => complianceUserFor.requirements.some((x) => x.id === reqId),
    setLawsSelectedForCompliance:(laws:any)=>setLawsSelectedForCompliance(laws)
  };
};
